<div class="input-wrapper">
  <!--animated no currency mask no title-->
  <ng-container *ngIf="animatedLabel && !hasCurrencyMask && !hasTitle && !hasPercent">
    <input [type]="type" class="app-input" maxlength="{{maxLength}}" [formControl]="control"
      [value]="controlValue || value" placeholder=" " min="{{minValue}}"
      [class.app-error-border]="(control.invalid && (control.dirty || control.touched))"
      [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" [attr.aria-label]="attAriaLabel"
      (ngModelChange)="onChange($event)" [attr.Id]="attrId" tabindex="0" #inp1 />
    <label class="label">{{ placeholder }}</label>
  </ng-container>
  <!--animated no currency mask with static title-->
  <ng-container *ngIf="!animatedLabel && !hasCurrencyMask && hasTitle && !hasPercent">
    <label class="app-title-xxsmall text-right m-0 mr-2">{{ placeholder}}</label>
    <input [type]="type" class="app-input" maxlength="{{maxLength}}" [formControl]="control"
      [value]="controlValue || value" [attr.aria-label]="attAriaLabel" min="{{minValue}}"
      [class.app-error-border]="(control.invalid && (control.dirty || !control.pristine) || (control.invalid && submitted))"
      [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" (ngModelChange)="onChange($event)" [attr.Id]="attrId"
      tabindex="0" #inp2 />
  </ng-container>
  <!--not animated has currency mask with static title-->
  <ng-container *ngIf="!animatedLabel && hasCurrencyMask && hasTitle && !hasPercent">
    <label class="app-title-xxsmall text-right m-0 mr-2">{{ placeholder}}</label>
    <input [type]="type" class="app-input" maxlength="{{maxLength}}" [(ngModel)]="value"
      [attr.aria-label]="attAriaLabel" min="{{minValue}}"
      [class.app-error-border]="(control.invalid && (control.dirty || !control.pristine) || (control.invalid && submitted))"
      currencyMask [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" (ngModelChange)="onChange($event)"
      [attr.Id]="attrId" tabindex="0" #inp3 />
  </ng-container>
  <!--not animated no currency mask no title-->
  <ng-container *ngIf="!animatedLabel && !hasCurrencyMask && !hasTitle && !hasPercent">
    <input [type]="type" class="app-input" maxlength="{{maxLength}}" [formControl]="control"
      [value]="controlValue || value" [attr.aria-label]="attAriaLabel" min="{{minValue}}"
      [class.app-error-border]="(control.invalid && (control.dirty || !control.pristine) || (control.invalid && submitted))"
      [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" (ngModelChange)="onChange($event)" [attr.Id]="attrId"
      tabindex="0" #inp4 />
  </ng-container>
  <!--not animated with currency mask no title-->
  <ng-container *ngIf="!animatedLabel && hasCurrencyMask  && !hasTitle && !hasPercent">
    <input [type]="type" class="app-input" placeholder="{{placeholder}}" [(ngModel)]="value"
      [attr.aria-label]="attAriaLabel" min="{{minValue}}"
      [class.app-error-border]="(control.invalid && (control.dirty || !control.pristine) || (control.invalid && submitted))"
      currencyMask [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" (ngModelChange)="onChange($event)"
      tabindex="0" #inp5 [attr.Id]="attrId" />
  </ng-container>
  <!--animated with currency mask no title-->
  <ng-container *ngIf="animatedLabel && hasCurrencyMask && !hasTitle && !hasPercent">
    <input [(ngModel)]="value" [type]="type" class="app-input" [attr.aria-label]="attAriaLabel"
      [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" currencyMask maxlength="{{maxLength}}" placeholder=" "
      min="{{minValue}}" (ngModelChange)="onChange($event)" />
    <label class="label">{{ placeholder }}</label>
  </ng-container>
  <!-- not animated with no currency mask no title with % -->
  <ng-container *ngIf="!animatedLabel && !hasCurrencyMask && !hasTitle && hasPercent">
    <input [type]="type" class="app-input" placeholder="{{placeholder}}" [(ngModel)]="value"
      [attr.aria-label]="attAriaLabel" min="{{minValue}}"
      [class.app-error-border]="(control.invalid && (control.dirty || !control.pristine) || (control.invalid && submitted))"
      appPercentageMask [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" (ngModelChange)="onChange($event)"
      tabindex="0" #inp6 [attr.Id]="attrId" />
  </ng-container>

</div>


// WEBPACK FOOTER //
// ./src/app/animated-input/animated-input.component.html